<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/users"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4 v-if="structure != null">
            <h4>
              Εισαγωγή/Επεξεργασία φορέων χρήστη : <u>{{ this.uName }}</u>
            </h4>
          </h4>
        </div>
      </div>

      <div>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        Περιφέρεια
        <DxSelectBox
          :search-enabled="true"
          :data-source="regions"
          search-mode="contains"
          search-expr="Description"
          :search-timeout="200"
          :min-search-length="2"
          :show-data-before-search="true"
          display-expr="Description"
          value-expr="Id"
          v-model="selectedRegionId"
          @value-changed="setSelectedRegion"
          placeholder="Επιλέξτε Περιφέρεια"
          :show-clear-button="true"
        />
      </div>
      <div class="col-md-2">
        Νομός
        <DxSelectBox
          :search-enabled="true"
          :data-source="counties"
          search-mode="contains"
          search-expr="Description"
          :search-timeout="200"
          :min-search-length="2"
          :show-data-before-search="true"
          display-expr="Description"
          value-expr="Id"
          v-model="selectedCountyId"
          @value-changed="setSelectedCounty"
          placeholder="Επιλέξτε Νομό"
          :show-clear-button="true"
        />
      </div>
      <div class="col-md-2">
        Δήμος
        <DxSelectBox
          :search-enabled="true"
          :data-source="municipalities"
          search-mode="contains"
          search-expr="Description"
          :search-timeout="200"
          :min-search-length="2"
          :show-data-before-search="true"
          display-expr="Description"
          value-expr="Id"
          v-model="selectedMunicipalityId"
          @value-changed="setSelectedMunicipality"
          placeholder="Επιλέξτε Δήμο"
          :show-clear-button="true"
          @on-opened="onOpened"
        />
      </div>
      <br />

      <div
        class="col-md-4"
        style="display: flex; flex-direction: row; justify-content: right"
      >
        <DxButton
          text=""
          type="danger"
          icon="clearformat"
          styling-mode="contained"
          style="margin: 1px"
          @click="clearFilters"
          hint="Καθαρισμός Κριτηρίων"
        />

        <DxButton
          text="Ανάθεση"
          type="success"
          icon="plus"
          styling-mode="contained"
          style="margin: 1px"
          @click="assignOrganizations"
          hint="Ανάθεση οργανισμών"
        />

        <DxButton
          text="Διαγραφή"
          type="danger"
          styling-mode="contained"
          icon="clear"
          style="margin: 1px"
          @click="deleteOrganizations"
          hint="Διαγραφή Ανατεθειμένων οργανισμών"
        />

        <DxButton
          text="Νέος Φορέας"
          type="success"
          styling-mode="contained"
          @click="addUserOrganizationsClick"
          style="margin: 1px"
        />
      </div>
    </div>
    <br />
    <h4>
      Με αυτά τα κριτήρια ο χρήστης {{ uName }} έχει ανατεθειμένους
      {{ rowsAffected }} φορείς από {{ totalRowsAffected }} συνολικά
    </h4>
    <div class="row">
      <div class="col-md-12 grid-pad">
        <DxDataGrid
          :data-source="userOrganizations"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :show-borders="true"
          key-expr="Id"
          width="100%"
          @row-removing="onRowRemoving"
          :show-row-lines="true"
          :row-alternation-enabled="true"
        >
          <DxPaging :page-size="20" />
          <DxEditing
            :allow-updating="false"
            :allow-adding="false"
            :use-icons="true"
            mode="form"
            :allow-deleting="true"
          />
          <DxHeaderFilter :visible="true" />
          <DxFilterRow :visible="true" />

          <DxColumn
            caption="Φορέας"
            data-field="OrganizationDescription"
            data-type="string"
            :visible="true"
            :allow-editing="true"
            alignment="left"
            width="50%"
          />

          <DxColumn
            caption="Δήμος"
            data-field="MunicipalityDescription"
            data-type="string"
            width="15%"
            alignment="left"
            :allow-editing="false"
          />

          <DxColumn
            caption="Νομός"
            data-field="CountyDescription"
            data-type="string"
            width="15%"
            alignment="left"
            :allow-editing="false"
          />

          <DxColumn
            caption="Περιφέρεια"
            data-field="RegionDescription"
            data-type="string"
            width="15%"
            alignment="left"
            :allow-editing="false"
          />

          <DxColumn type="buttons" width="5%">
            <!--    <gridButton hint="Αλλαγή φορέα" icon="edit" :on-click="editUserOrganizationsClick"/>   -->
            <gridButton name="delete" hint="Διαγραφή φορέα" />
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              column="OrganizationDescription"
              summary-type="count"
            />
          </DxSummary>
        </DxDataGrid>
      </div>
    </div>

    <DxPopup
      :visible="popupVisible"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-title="true"
      :show-close-button="false"
      :width="500"
      :height="200"
      :title="popupTitle"
    >
      <DxLookup
        :data-source="lookupOrganizations"
        value-expr="Id"
        display-expr="Description"
        placeholder="Επιλέξτε Φορέα"
        v-model="selectedOrganizationId"
      >
        <DxDropDownOptions :shading="false" :full-screen="false" />
      </DxLookup>

      <br />
      <DxButton
        text="Αποθήκευση"
        type="success"
        styling-mode="contained"
        @click="saveFromPopup"
      />

      <DxButton
        text="Επιστροφή"
        type="danger"
        styling-mode="contained"
        @click="closePopup"
      />
    </DxPopup>
  </div>
</template>



<script>
import mainService from "../../services/mainService";
import { DxDropDownOptions, DxLookup } from "devextreme-vue/lookup";
import DxButton from "devextreme-vue/button";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxPaging,
  DxFilterRow,
  DxEditing,
  DxTotalItem,
  DxSummary,
} from "devextreme-vue/data-grid";
import { DxButton as gridButton } from "devextreme-vue/data-grid";
import { DxSelectBox } from "devextreme-vue/select-box";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import { DxPopup } from "devextreme-vue/popup";
import notify from "devextreme/ui/notify";
import BackButton from "../../components/shared/backButton";

export default {
  components: {
    DxLookup,
    DxDropDownOptions,
    DxButton,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxDataGrid,
    DxFilterRow,
    DxPopup,
    gridButton,
    DxSelectBox,
    DxTotalItem,
    DxSummary,
    BackButton,
    DxLoadIndicator,
  },
  props: ["uId", "uName"],
  data() {
    return {
      userId: 0,
      nickName: "",
      regions: [],
      selectedRegionId: 0,
      counties: [],
      selectedCountyId: 0,
      municipalities: [],
      selectedMunicipalityId: 0,
      userOrganizations: [],
      lookupOrganizations: [],
      popupVisible: false,
      popupTitle: "",
      action: "",
      selectedOrganizationId: 0,
      selectedUserOrganizationId: 0,
      rowsAffected: 0,
      totalRowsAffected: 0,
      loadIndicatorVisible: false,
    };
  },
  methods: {
    onOpened() {
      alert("hello");
    },
    clearFilters() {
      this.selectedRegionId = 0;
      this.setSelectedCountyId = 0;
      this.setSelectedMunicipalityId = 0;
    },
    async setSelectedRegion(e) {
      this.clearCounties();
      this.clearMunicipalities();

      if (e.value != null) {
        this.selectedRegionId = e.value;
        const _res = await mainService.get(
          `/Counties/GetCountiesByRegionId?regionid=${e.value}`
        );
        this.counties = _res.data;
      } else {
        this.selectedRegionId = 0;
      }

      this.assignOrganizationsActions(0);
    },
    async setSelectedCounty(e) {
      this.clearMunicipalities();

      if (e.value != null) {
        this.selectedCountyId = e.value;
        const _res = await mainService.get(
          `/Municipalities/GetMunicipalitiesByCountyId?countyId=${e.value}`
        );
        this.municipalities = _res.data;
      } else {
        this.selectedCountyId = 0;
      }
      this.assignOrganizationsActions(0);
    },
    async setSelectedMunicipality(e) {
      if (e.value != null) {
        this.selectedMunicipalityId = e.value;
      } else {
        this.selectedMunicipalityId = 0;
      }
      this.assignOrganizationsActions(0);
    },
    setSelectedOrganization(e) {
      this.selectedOrganizationId = e.value;
    },
    clearCounties() {
      this.counties = [];
      this.selectedCountyId = 0;
    },
    clearMunicipalities() {
      this.municipalities = [];
      this.selectedMunicipalityId = 0;
    },
    async assignOrganizationsActions(actionType) {
      var s = `/UserOrganizations/UserOrganizations_Assign?userId=${this.userId}&regionId=${this.selectedRegionId}&countyId=${this.selectedCountyId}&municipalityId=${this.selectedMunicipalityId}&actionType=${actionType}`;

      const _res = await mainService.get(
        `/UserOrganizations/UserOrganizations_Assign?userId=${this.userId}&regionId=${this.selectedRegionId}&countyId=${this.selectedCountyId}&municipalityId=${this.selectedMunicipalityId}&actionType=${actionType}`
      ); //read Action
      this.rowsAffected = _res.data.rowsAffected;
      this.totalRowsAffected = _res.data.totalRowsAffected;
    },
    async assignOrganizations() {
      await this.assignOrganizationsActions(1);
      await this.assignOrganizationsActions(0);
      await this.getUserOrganizations();
    },
    async deleteOrganizations() {
      await this.assignOrganizationsActions(2);
      await this.assignOrganizationsActions(0);
      await this.getUserOrganizations();
    },
    async addUserOrganizationsClick(e) {
      this.action = "ADD";
      this.popupVisible = true;
      this.popupTitle = "Προσθήκη φορέα";
      const _res = await mainService.get(
        `/Organizations/GetFilteredUserOrganizationsByUserId?userId=${this.userId}`
      );
      this.lookupOrganizations = _res.data;
    },
    async editUserOrganizationsClick(e) {
      this.action = "EDIT";
      this.popupVisible = true;
      this.popupTitle = "Επεξεργασία φορέα";
      const _res = await mainService.get(
        `/Organizations/GetFilteredUserOrganizationsByUserId?userId=${this.userId}`
      );
      this.lookupOrganizations = _res.data;
      this.selectedUserOrganizationId = e.row.data.Id;
    },
    async saveFromPopup(e) {
      this.popupVisible = false;
      var userOrganization = {
        Id: this.selectedUserOrganizationId,
        UserId: this.userId,
        OrganizationId: this.selectedOrganizationId,
      };

      var _res = null;
      if (userOrganization.OrganizationId != 0) {
        //user has selected an organization from popup

        if (this.action == "ADD") {
          _res = await mainService.post(
            "/UserOrganizations/AddUserOrganization",
            userOrganization
          );
          await this.assignOrganizationsActions(0);
        } else if (this.action == "EDIT") {
          
          _res = await mainService.post(
            "/UserOrganizations/UpdateUserOrganization",
            userOrganization
          );
        }

        this.getUserOrganizations();
      }

      this.selectedOrganizationId = 0;
      this.action = "";
    },
    async onRowRemoving(e) {
      var _res = await mainService.delete(
        `/UserOrganizations/DeleteUserOrganization?id=${e.data.Id}`
      );
      if (_res.data != true) {
        notify("Πρόβλημα κατά την Διαγραφή", "error", 1000);
      }
      this.getUserOrganizations();
      await this.assignOrganizationsActions(0);
    },
    closePopup(e) {
      this.popupVisible = false;
    },
    async getUserOrganizations() {
      this.loadIndicatorVisible = true;
      var _res = await mainService.get(
        `/UserOrganizations/GetUserOrganizationsByUserId?userId=${this.userId}`
      );
      this.userOrganizations = _res.data;
      this.loadIndicatorVisible = false;
    },
  },
  created() {
    this.userId = this.uId;
    this.nickName = this.uName;
  },
  async mounted() {
    var _res = await mainService.get(`/Regions/GetRegions`);
    this.regions = _res.data;
    this.getUserOrganizations();
    this.assignOrganizationsActions(0);
  },
};
</script>

<style scoped>
</style>
